import * as Constants from '../../utilities/constants/Constants';
import {
  getURLExtension,
  isARCEnabled
} from '../../utilities/HelperFunctions/HelperFunctions';
import { minimumZIndex, isGroupEnabled } from '../../redux/fabricCanvasActions';
import {
  isImageBasedBackground,
  isBackground,
  canvasElementsExceptBackground,
  canDuplicateElement,
  isWallLayout,
  isSolidFillBackground
} from '../../redux/fabricCanvasActionHelpers';

export const handleBasicValidation = selectedObject =>
  selectedObject != null && selectedObject.placing;

export const isActiveSelection = selectedObject =>
  selectedObject && selectedObject.type !== 'activeSelection';

export const isCanvasRoomMode = (viewType, isCanvas) =>
  isCanvas && viewType === Constants.THREE_D_TYPE;

export const isElementRecolorable = placing => {
  if (placing.placeableType === Constants.USER_PHOTO_TYPE) {
    if (
      placing.placeable.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE
    ) {
      if (placing.placeable.metadata) {
        return placing.placeable.metadata.recolorable;
      }
    } else if (
      placing.placeable.imageSource === Constants.VECTEEZY_IMAGE_SOURCE
    ) {
      return true;
    } else if (
      placing.placeable.imageSource === Constants.HP_MOSAIC_IMAGE_SOURCE
    ) {
      return true;
    } else {
      return (
        placing.placeable.svgColors && placing.placeable.svgColors.length > 0
      );
    }
  } else if (
    placing.placeableType === Constants.SCENE_KEY ||
    placing.placeableType === Constants.ELEMENT_KEY
  ) {
    return (
      placing.placeable.svgColors && placing.placeable.svgColors.length > 0
    );
  }
  return false;
};

export const canAddRecolorTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      if (handleBasicValidation(selectedObject)) {
        return isElementRecolorable(selectedObject.placing);
      }
    }
  }
  return false;
};

export const canAddTileTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    let validate = false;
    if (isActiveSelection(selectedObject)) {
      if (
        Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
        (selectedObject.placing.placeable.imageSource ===
          Constants.PATTERN_DESIGN_IMAGE_SOURCE ||
          selectedObject.placing.placeable.imageSource ===
            Constants.HP_MOSAIC_IMAGE_SOURCE)
      ) {
        return false;
      }
      if (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        !selectedObject.placing.tiled &&
        !sharedScene
      ) {
        validate = true;
      }
    }
    return validate;
  }
  return false;
};

export const canAddUnTileTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    let validate = false;
    if (isActiveSelection(selectedObject)) {
      if (
        Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
        (selectedObject.placing.placeable.imageSource ===
          Constants.PATTERN_DESIGN_IMAGE_SOURCE ||
          selectedObject.placing.placeable.imageSource ===
            Constants.HP_MOSAIC_IMAGE_SOURCE)
      ) {
        return false;
      }
      if (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        selectedObject.placing.tiled &&
        !sharedScene
      ) {
        validate = true;
      }
    }
    return validate;
  }
  return false;
};

export const canAddTransparencyTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    let canAddTransparencyButton = false;
    if (isActiveSelection(selectedObject)) {
      if (handleBasicValidation(selectedObject)) {
        if (
          isBackground(selectedObject) ||
          (Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
            selectedObject.placing.placeable.externalPlaceable)
        ) {
          canAddTransparencyButton = false;
        } else if (
          selectedObject.placing.placeableType === Constants.TEXT_ELEMENT_TYPE
        ) {
          canAddTransparencyButton = true;
        } else if (
          Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
          selectedObject.placing.placeable.svgColors &&
          selectedObject.placing.placeable.svgColors.length > 0
        ) {
          canAddTransparencyButton = true;
        } else if (
          selectedObject.placing.placeableType === Constants.USER_PHOTO_TYPE
        ) {
          if (
            selectedObject.placing.placeable.imageSource ===
              Constants.UNSPLASH_IMAGE_SOURCE ||
            selectedObject.placing.placeable.imageSource ===
              Constants.INSTAGRAM_IMAGE_SOURCE
          ) {
            canAddTransparencyButton = false;
          } else if (
            selectedObject.placing.placeable.imageSource ===
            Constants.VECTEEZY_IMAGE_SOURCE
          ) {
            canAddTransparencyButton = true;
          } else if (
            Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
            Object.prototype.hasOwnProperty.call(
              selectedObject.placing.placeable,
              'printableImagePath'
            ) &&
            selectedObject.placing.placeable.printableImagePath
          ) {
            const supportedImageFormats = ['svg', 'png'];
            const extension = getURLExtension(
              selectedObject.placing.placeable.printableImagePath
            );
            canAddTransparencyButton = supportedImageFormats.includes(
              extension
            );
          }
        } else if (
          Object.prototype.hasOwnProperty.call(selectedObject, 'placing') &&
          Object.prototype.hasOwnProperty.call(
            selectedObject.placing.placeable,
            'printableImageUrl'
          ) &&
          selectedObject.placing.placeable.printableImageUrl
        ) {
          const supportedImageFormats = ['svg', 'png'];
          const extension = getURLExtension(
            selectedObject.placing.placeable.printableImageUrl
          );
          canAddTransparencyButton = supportedImageFormats.includes(extension);
        }
      }
    }
    return canAddTransparencyButton;
  }
  return false;
};

export const canAddDuplicateTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        canDuplicateElement(selectedObject)
      );
    }
  }
  return false;
};

export const canAddRotateTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject) &&
        !isWallLayout(selectedObject)
      );
    }
  }
  return false;
};

export const canAddAlignTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject) &&
        !isWallLayout(selectedObject)
      );
    }
    return true;
  }
  return false;
};

export const canAddResizeArbitrarilyTool = (
  viewType,
  isCanvas,
  selectedObject
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (!isCanvasRoomMode(viewType, isCanvas)) {
      if (isActiveSelection(selectedObject)) {
        return (
          handleBasicValidation(selectedObject) &&
          !isBackground(selectedObject) &&
          !isWallLayout(selectedObject) &&
          Object.prototype.hasOwnProperty.call(selectedObject, 'resizeType') &&
          selectedObject.resizeType !== 'arbitrarily'
        );
      }
    }
  }
  return false;
};

export const canAddResizeProportionallyTool = (
  viewType,
  isCanvas,
  selectedObject
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject) &&
        !isWallLayout(selectedObject) &&
        Object.prototype.hasOwnProperty.call(selectedObject, 'resizeType') &&
        selectedObject.resizeType === 'arbitrarily'
      );
    }
  }
  return false;
};

export const canAddScaleTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        !sharedScene &&
        !isARCEnabled(projectCategory, partnerStoreType)
      );
    }
  }
  return false;
};

export const canAddScaleAllTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        !sharedScene &&
        canvasElementsExceptBackground(canvas).length > 0 &&
        !selectedObject.placing.tiled &&
        !isARCEnabled(projectCategory, partnerStoreType)
      );
    }
  }
  return false;
};

export const canAddClearAllTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isBackground(selectedObject) &&
        canvasElementsExceptBackground(canvas).length > 0
      );
    }
  }
  return false;
};

export const canAddLockTool = (viewType, isCanvas, selectedObject) => {
  const selectedObjects = [];
  if (selectedObject && selectedObject.type === 'activeSelection') {
    selectedObject.forEachObject(ele => {
      selectedObjects.push(ele);
    });
  } else {
    selectedObjects.push(selectedObject);
  }

  let canAddLock = true;
  selectedObjects.forEach(ele => {
    if (
      handleBasicValidation(ele) &&
      ele.placing.placeableType == Constants.PROJECT_KEY
    ) {
      canAddLock = !ele.placing.locked;
    } else {
      canAddLock =
        canAddLock && handleBasicValidation(ele) && !ele.lockMovementX;
    }
  });
  return canAddLock;
};

export const canAddUnlockTool = (viewType, isCanvas, selectedObject) => {
  const selectedObjects = [];
  if (selectedObject && selectedObject.type === 'activeSelection') {
    selectedObject.forEachObject(ele => {
      selectedObjects.push(ele);
    });
  } else {
    selectedObjects.push(selectedObject);
  }

  let canAddUnLock = true;
  selectedObjects.forEach(ele => {
    if (
      handleBasicValidation(ele) &&
      ele.placing.placeableType == Constants.PROJECT_KEY
    ) {
      canAddUnLock = ele.placing.locked;
    } else {
      canAddUnLock =
        canAddUnLock && handleBasicValidation(ele) && ele.lockMovementX;
    }
  });
  return canAddUnLock;
};

export const canAddSetSizeTool = (viewType, isCanvas, selectedObject) => {
  if (isActiveSelection(selectedObject)) {
    return (
      handleBasicValidation(selectedObject) && isWallLayout(selectedObject)
    );
  }
  return false;
};

export const canAddDeleteTool = (viewType, isCanvas, selectedObject) =>
  handleBasicValidation(selectedObject) &&
  selectedObject.placing.placeableType != Constants.PROJECT_KEY;

//  if there are no view types for giftwrap then no need to check for room mode
export const canAddZoomInTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory
) => {
  if (projectCategory === Constants.GIFTWRAPS_CATEGORY) return true;
  return false;
};

export const canAddZoomOutTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory
) => {
  if (projectCategory === Constants.GIFTWRAPS_CATEGORY) return true;
  return false;
};

export const canAddSendToBackTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      if (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject)
      ) {
        const minZIndex = minimumZIndex(canvas);
        const allContents = canvas.getObjects();
        if (allContents.indexOf(selectedObject) === minZIndex) return false;
        return true;
      }
    }
  }
  return false;
};

export const canAddBringToFrontTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      if (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject)
      ) {
        const allContents = canvas.getObjects();
        if (allContents.indexOf(selectedObject) === allContents.length - 1) {
          return false;
        }
        return true;
      }
    }
  }
  return false;
};

export const canAddFlipTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      if (handleBasicValidation(selectedObject)) {
        if (
          (isImageBasedBackground(selectedObject) &&
            selectedObject.placing.tiled) ||
          isWallLayout(selectedObject) ||
          selectedObject.placing.placeableType ===
            Constants.TEXT_ELEMENT_TYPE ||
          isSolidFillBackground(selectedObject)
        ) {
          return false;
        }
        if (Object.prototype.hasOwnProperty.call(selectedObject, 'placing')) {
          if (
            Object.prototype.hasOwnProperty.call(
              selectedObject.placing.placeable,
              'flippableX'
            )
          ) {
            return selectedObject.placing.placeable.flippableX;
          }
          return true;
        }
        return false;
      }
      return false;
    }
    return true;
  }
  return false;
};

export const canAddScaleToFillTool = (viewType, isCanvas, selectedObject) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        !isBackground(selectedObject) &&
        !isWallLayout(selectedObject) &&
        selectedObject.placing.placeableType !== Constants.TEXT_ELEMENT_TYPE
      );
    }
  }
  return false;
};

export const canAddGroupTool = (viewType, isCanvas, selectedObject, canvas) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isBackground(selectedObject) &&
        canvasElementsExceptBackground(canvas).length > 0 &&
        !selectedObject.placing.tiled &&
        !isGroupEnabled(canvas)
      );
    }
  }
  return false;
};

export const canAddUngroupTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isBackground(selectedObject) &&
        canvasElementsExceptBackground(canvas).length > 0 &&
        !selectedObject.placing.tiled &&
        isGroupEnabled(canvas)
      );
    }
  }
  return false;
};

export const canAddStretchTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        !selectedObject.placing.tiled &&
        hasMultiwalls &&
        !sharedScene
      );
    }
  }
  return false;
};

export const canAddUnstretchTool = (
  viewType,
  isCanvas,
  selectedObject,
  canvas,
  projectCategory,
  partnerStoreType,
  hasMultiwalls,
  sharedScene
) => {
  if (!isCanvasRoomMode(viewType, isCanvas)) {
    if (isActiveSelection(selectedObject)) {
      return (
        handleBasicValidation(selectedObject) &&
        isImageBasedBackground(selectedObject) &&
        !selectedObject.placing.tiled &&
        hasMultiwalls &&
        sharedScene
      );
    }
  }
  return false;
};
